import React, { Component, useEffect } from "react";
import {
  Progress,
  Button,
  Form,
  FormGroup,
  Label,
  Col,
  Container,
  Row,
  Input,
  FormText,
} from "reactstrap";
import Select from "react-select";
import { connect } from "react-redux";
import SelectListComponent from "../utils/selectList";
import DateSelector from "../utils/dateSelector";
import moment from "moment";
import NotificationSystem from "react-notification-system";
import { addLog, apiActions, modalActions } from "../../_actions";
import { appConstants } from "../../_constants";
import { appHelpers } from "../../_helpers";
import SelectCreatableListComponent from "../utils/selectCreatableList";
import { commonService } from "../../_services";
import { commonActions } from "../../_actions";
import { store } from "../../_helpers";
import { history } from "../../_helpers";

const Currency = [
  { name: "Naira", id: 566 },
  { value: 566, label: "Naira" },
  { name: "Dollar", id: 840 },
  { value: 840, label: "Dollar" },
];
const ViewHeader = () => (
  <div className="view-header d-flex align-items-center">
    <header className="text-white">
      <h1 className="h5 title text-uppercase">EDIT DATA ENTRY</h1>
    </header>
  </div>
);

const ViewContent = ({ children }) => (
  <div className="view-content view-components" style={{ marginTop: "30px" }}>
    {children}
  </div>
);
class PdmEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      openModal: false,
      airlineName: "",
      currency: "",
      depName: "",
      desName: "",
      airlines: [],
      flights: [],
      AirlineId: "",
      searchAirlineId: "",
      filteredFlightNumbers: [],
      searchFlightNumber: "",
      FlightNumber: "",
      DepartureDate: new Date(),
      departureAirports: [],
      DepartureAirportId: "",
      destinationAirports: [],
      DestinationAirportId: "",
      selectedOption: "",
      IsLocal: false,
      PAXCount: "",
      TSCAmount: "",
      Matched: true,
      url: `${appConstants.PAS_URL}//api/PostDepartureManifest/update`, // Updated for edit flow
      // Error handling
      contentError: false,
      componentError: false,
      componentErrorMessages: [],
      error: false,
      success: false,
      // Notification
      notification: {
        message: "Default Message",
        level: "success",
        dismissible: true,
      },
      contentErrorText: false,
      currencies: [
        { value: 566, label: "Naira" },
        { value: 840, label: "Dollar" },
      ],
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    const { record } = this.props.location.state; // Access the record from location state
    const reduxState = store.getState();
    if (reduxState.airlinesCarriers) {
      // const localAirlines = reduxState.airlines.Results.filter(item => item.IsLocal);
      this.setState({
        airlines: this.formatAirlines(reduxState.airlinesCarriers.Results),
        AirlineId: this.formatAirlines(reduxState.airlinesCarriers.Results).Id,
      });
    } else {
      this.fetchAirlines();
    }

    // Fetch Destination Airports
    if (reduxState.desAirports) {
      this.setState({
        desAirports: this.formatDestinationAirports(
          reduxState.desAirports.Results
        ),
      });
    } else {
      this.fetchDesAirports();
    }
    // Fetch Departure Airports
    if (reduxState.depAirports) {
      this.setState({
        depAirports: this.formatDepartureAirports(
          reduxState.depAirports.Results
        ),
      });
    } else {
      this.fetchDepAirports();
    }

    if (record) {
      this.setState({
        searchAirlineId: record.AirlineId,
        searchFlightNumber: record.FlightNumber,
        DepartureAirportId: record.DepartureAirportId,
        DestinationAirportId: record.DestinationAirportId,
        DepartureDate:record.DepartureDate,
        PAXCount: record.PdmPAX,
        TSCAmount: record.PdmTSCAmount,
        PdmId: record.PdmId,
        selectedOption: {
            value: record.PdmCurrencyId,
            label: this.findCurrency(record.PdmCurrencyId),
          },
        }, () => {
          // Ensure that filtered flight numbers are fetched before setting flight number
          this.fetchAirlineFlightNumbers(record.AirlineId);
        });
      }
    }

  findCurrency = (currencyId) => {
    const { currencies } = this.state;
    const currency = currencies.find((item) => item.value === currencyId);
    return currency ? currency.label : "";
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded =
      this._notificationSystem.addNotification(notification);
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { dispatch } = this.props;
    const { record } = this.props.match.params; // Get the record ID from the URL

    const payload = {
      AirlineId: this.state.searchAirlineId,
      DepartureDate: this.state.DepartureDate,
      FlightNumber: this.state.searchFlightNumber,
      DepartureAirportId: this.state.DepartureAirportId,
      DestinationAirportId: this.state.DestinationAirportId,
      PassengersCount: Number(this.state.PAXCount),
      TSCAmount: this.state.TSCAmount,
      CurrencyId: Number(this.state.selectedOption.value),
      CreatedBy: appHelpers.getActiveUser().userName,
      Id: this.state.PdmId, 
    };
    dispatch(apiActions.startRequest());
    commonService.updatePdmRecord(payload).then((res) => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.notify("Record updated successfully", appConstants.NOTIFY_SUCCESS);
        setTimeout(() => {
          history.push("/pdm-report");
        }, 4000);
      } else {
        let errorMessage = "Failed to update record";
        
        if (res.response && res.response.ErrorMessages && res.response.ErrorMessages.length > 0) {
          errorMessage = res.response.ErrorMessages.join(", ");
        }
        
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
      }
      dispatch(apiActions.endRequest());
    }).catch((error) => {
      dispatch(apiActions.endRequest());
      this.notify("An error occurred while updating the record", appConstants.NOTIFY_ERROR);
    });
  };

  validateInput = () => {
    let _errs_ = [];
    let formValid = true;
    const {
      searchFlightNumber,
      searchAirlineId,
      DepartureAirportId,
      DestinationAirportId,
      PAXCount,
      TSCAmount,
      selectedOption,
    } = this.state;

    if (searchAirlineId === "") {
      _errs_["searchAirlineId"] = "Please select airline";
      formValid = false;
    }
    if (searchFlightNumber === "") {
      _errs_["searchFlightNumber"] = "Please enter flight number";
      formValid = false;
    }
    if (DepartureAirportId === "") {
      _errs_["DepartureAirportId"] = "Please select departure airport";
      formValid = false;
    }
    if (DestinationAirportId === "") {
      _errs_["DestinationAirportId"] = "Please select destination airport";
      formValid = false;
    }
    if (PAXCount === "") {
      _errs_["PAXCount"] = "Please enter Pax Count";
      formValid = false;
    }
    if (TSCAmount.length > 0 && selectedOption === "") {
      _errs_["Currency"] = "Please select Currency";
      formValid = false;
    }

    this.setState({ componentErrorMessages: _errs_ });
    return formValid;
  };

  handleAirlineChange = (target) => {
    let errorMessages = this.state.componentErrorMessages;
    errorMessages["searchAirlineId"] = false;
    if (!(target === null && this.state.searchAirlineId === "")) {
      let airlineId = target ? target.Id : "";
      this.setState({
        componentErrorMessages: errorMessages,
        searchAirlineId: airlineId,
        filteredFlightNumbers: [],
        searchFlightNumber: "",
      });
      this.fetchAirlineFlightNumbers(airlineId);
    }
  };

  fetchAirlines = () => {
    const { dispatch } = this.props;
    // this.setState({contentError: false});
    dispatch(apiActions.startFullPageRequest());

    dispatch(commonActions.getAirlinesCarriers())
      .then(() => {
        const { airlinesCarriers } = this.props;
        this.setState({
          airlines: this.formatAirlines(airlinesCarriers.Results),
        });
        //this.formatAirlines(res.data.Results);
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        // this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

fetchAirlineFlightNumbers = (airlineId) => {
    this.setState({ contentError: false, filteredFlightNumbers: [] });
    const { dispatch } = this.props;
  
    dispatch(apiActions.startRequest());
  
    commonService.getAirlinesFlightNumbers(airlineId).then((res) => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        const flightNumbers = res.response.Results;
        this.setState({ filteredFlightNumbers: flightNumbers }, () => {
          // Prefill flight number if a record exists
          if (this.state.searchFlightNumber) {
            const matchingFlight = flightNumbers.find(
              (f) => f.FlightNumber === this.state.searchFlightNumber
            );
            if (matchingFlight) {
              this.handleFlightChange(matchingFlight);
            }
          }
        });
  
        dispatch(apiActions.endRequest());
      } else {
        this.notify("Failed to fetch flight numbers", appConstants.NOTIFY_ERROR);
      }
    });
  };
  

// handleFlightChange = (target) => {
//     let errorMessages = { ...this.state.componentErrorMessages };
//     errorMessages["searchFlightNumber"] = false; 
//     this.setState(
//         {
//           DepartureAirportId: "",
//           DestinationAirportId: "",
//         },
//         () => {
//           // Step 2: Set the correct values
//           this.setState(
//             {
//               componentErrorMessages: errorMessages,
//               searchFlightNumber: target.FlightNumber || "",
//               DepartureAirportId: target.DepartureAirportId || this.state.DepartureAirportId,
//               DestinationAirportId: target.DestinationAirportId || this.state.DestinationAirportId,
//               selectedFlightId: target.Id,
//             },
//             () => {

//               console.log("Updated State:", this.state.DepartureAirportId, this.state.DestinationAirportId);
//             }
//           );
//         }
//       );
//   };
 
handleFlightChange = (target) => {
  let errorMessages = { ...this.state.componentErrorMessages };
  errorMessages["searchFlightNumber"] = false;

  if (!target) {
    this.setState({
      componentErrorMessages: errorMessages,
      searchFlightNumber: "",
      DepartureAirportId: "",
      DestinationAirportId: "",
      selectedFlightId: "",
    });
    return;
  }

  this.setState({
    componentErrorMessages: errorMessages,
    searchFlightNumber: target.FlightNumber || "",
    DepartureAirportId: target.DepartureAirportId || "",
    DestinationAirportId: target.DestinationAirportId || "",
    selectedFlightId: target.Id,
  });
};

  handleSelectChange = (payload, attribute, stateAttribute) => {
    let currState = this.state;
    currState[stateAttribute] = payload ? payload[attribute] : "";
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[stateAttribute] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
  };

  paxChange = (event) => {
    let errorMessages = this.state.componentErrorMessages;
    errorMessages["PAXCount"] = false;
    this.setState({
      componentErrorMessages: errorMessages,
      PAXCount: event.target.value,
    });
  };

  tscAmountChange = (event) => {
    this.setState({ TSCAmount: event.target.value });
  };

  handleCurrencyChange = (selectedOption) => {
    let errorMessages = this.state.componentErrorMessages;
    errorMessages["searchFlightNumber"] = false;
    this.setState({
      selectedOption: selectedOption,
      componentErrorMessages: errorMessages,
    });
  };
  fetchDepAirports = () => {
    const { dispatch } = this.props;
    this.setState({ contentError: false });
    dispatch(apiActions.startFullPageRequest());

    dispatch(commonActions.getDepAirports())
      .then(() => {
        const airports = this.props.depAirports;
        //
        let depAirports = airports.Results;
        depAirports = this.formatDepartureAirports(depAirports);
        this.setState({ depAirports });
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        // this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };
  fetchDesAirports = () => {
    const { dispatch } = this.props;
    this.setState({ contentError: false });
    dispatch(apiActions.startFullPageRequest());

    dispatch(commonActions.getDesAirports())
      .then(() => {
        const airports = this.props.desAirports;
        let desAirports = airports.Results;
        desAirports = this.formatDestinationAirports(desAirports);
        this.setState({
          desAirports,
        });
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        // this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };
  
  getDesAirport() {
    const { DestinationAirportId } = this.state;
    const { destinationAirports } = this.props;
    let getDes = destinationAirports.find(
      (destination) => destination.Id === DestinationAirportId
    );
    let desName = getDes.Name;
    this.setState({ desName });
  }
  getDepAirport() {
    const { DepartureAirportId } = this.state;
    const { departureAirports } = this.props;
    let getDep = departureAirports.find(
      (departure) => departure.Id === DepartureAirportId
    );
    let depName = getDep.Name;
    this.setState({ depName });
  }
  findAirport = (DepartureAirportId) => {
    const { departureAirports } = this.props;
    let airport = departureAirports.find(
      (departure) => departure.Id === DepartureAirportId
    );
    return airport ? airport.Name : "Unknown Airport";
  };
  formatAirlines = (res) => {
    let data = [];

    for (let item of res) {
      item["cat"] = "AirlineId";
      item["label"] = `${item.Name} (${item.Code})`;
      item["value"] = item.Id;
      data.push(item);
    }

    return data;
  };
  formatDestinationAirports = (res) => {
    let data = [];

    for (let item of res) {
      item["cat"] = "DestinationAirportId";
      item["label"] = `${item.Name} (${item.Code})`;
      item["value"] = item.Id;
      data.push(item);
    }

    return data;
  };
 
  formatDepartureAirports = (res) => {
    let data = [];
    for (let item of res) {
      item["cat"] = "DepartureAirportId";
      item["label"] = `${item.Name} (${item.Code})`;
      item["value"] = item.Id;
      data.push(item);
    }

    return data;
  };

  render() {
    let {
      searchAirlineId,
      searchFlightNumber,
      DepartureAirportId,
      DestinationAirportId,
      DepartureDate,
      PAXCount,
      TSCAmount,
      selectedOption,
      airlines,
      departureAirports,
      destinationAirports,
      currencies,
      componentErrorMessages,
      filteredFlightNumbers,
      contentError,
      depAirports, desAirports
    } = this.state;
    const { requesting, pageRequesting } = this.props;
    return (
      <div className="view">
        <Form ref={this.form} onSubmit={(e) => e.preventDefault()}>
          <ViewHeader />
          <ViewContent>
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                striped
                animated
                color="success"
                value={100}
                className="mb-2"
              />
            )}

            <Row>
              <Col md="6">
                <FormGroup className="mb-4">
                  <Label for="Airline">Airline</Label>
                  <SelectListComponent
                    placeholder={"Select Airline..."}
                    data={airlines}
                    valueKey="Id"
                    textField="Name"
                    selectValue={searchAirlineId}
                    onValueChange={(payload) =>
                      this.handleAirlineChange(payload)
                    }
                  />
                  {componentErrorMessages.searchAirlineId && (
                    <FormText color="danger">
                      {" "}
                      {componentErrorMessages.searchAirlineId}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-4">
                  <Label for="FlightNumber">Flight Number</Label>
                  <SelectCreatableListComponent
                    data={filteredFlightNumbers}
                    placeholder={"Type Flight Number"}
                    valueKey="FlightNumber"
                    textField="FlightNumber"
                    selectValue={searchFlightNumber}
                    onValueChange={(payload) =>
                      this.handleFlightChange(payload)
                    }
                  />
                  {componentErrorMessages.searchFlightNumber && (
                    <FormText color="danger">
                      {" "}
                      {componentErrorMessages.searchFlightNumber}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-4">
                  <Label for="DepartureAirportId">Departure Airport</Label>
                  <SelectListComponent
                    data={depAirports}
                    valueKey="Id"
                    textField="Name"
                    selectValue={DepartureAirportId}
                    onValueChange={(payload) =>
                      this.handleSelectChange(
                        payload,
                        "Id",
                        "DepartureAirportId"
                      )
                    }
                  />
                  {componentErrorMessages.DepartureAirportId && (
                    <FormText color="danger">
                      {" "}
                      {componentErrorMessages.DepartureAirportId}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-4">
                  <Label for="DestinationAirportId">Destination Airport</Label>
                  <SelectListComponent
                    data={desAirports}
                    valueKey="Id"
                    textField="Name"
                    selectValue={DestinationAirportId} 
                    onValueChange={(payload) =>
                      this.handleSelectChange(
                        payload,
                        "Id",
                        "DestinationAirportId"
                      )
                    }
                  />
                  {componentErrorMessages.DestinationAirportId && (
                    <FormText color="danger">
                      {" "}
                      {componentErrorMessages.DestinationAirportId}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-4">
                  <Label for="FlightDate">Flight Date</Label>
                  <DateSelector
                    maxDate={new Date()}
                    todayDate={moment(DepartureDate).format("YYYY-MM-DD")}
                    name="startDate"
                    // selectedDate={DepartureDate}  // Pass the state value
                    onValueChange={(DepartureDate) =>
                      this.setState({ DepartureDate })
                    }
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-4">
                  <Label for="PAXCount">PAX Count</Label>
                  <Input
                    type="number"
                    name="select"
                    value={this.state.PAXCount}
                    onChange={this.paxChange.bind(this)}
                  />
                  {componentErrorMessages.PAXCount && (
                    <FormText color="danger">
                      {" "}
                      {componentErrorMessages.PAXCount}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-1">
                  <Label>TSC Amount</Label>
                  <Input
                    type="number"
                    value={this.state.TSCAmount}
                    name="select"
                    onChange={this.tscAmountChange.bind(this)}
                    disabled
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className={"mb-1"}>
                  <Label for="Currency"> Currency</Label>
                  <Select
                    name="form-field-name"
                    value={selectedOption}
                    onChange={this.handleCurrencyChange}
                    options={currencies}
                    disabled
                  />
                  {componentErrorMessages.Currency && (
                    <FormText color="danger">
                      {" "}
                      {componentErrorMessages.Currency}
                    </FormText>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col xs="6" sm="2">
                <label>&nbsp;</label>
                <Button
                  className="btn-avi-primary btn-block"
                  onClick={this.handleSubmit.bind(this)}
                >
                  {" "}
                  Update Record
                </Button>
                <br />
              </Col>
            </Row>
          </ViewContent>
          <NotificationSystem ref="notificationSystem" />
        </Form>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    requesting: state.api.requesting,
    pageRequesting: state.api.pageRequesting,
    modal: state.modal,
    user: state.authentication.user,
    airlinesCarriers: state.airlinesCarriers,
    desAirports: state.desAirports,
    depAirports: state.depAirports,
  };
}

export default connect(mapStateToProps)(PdmEdit);



// WEBPACK FOOTER //
// ./src/views/pdm-data-entry/edit-pdm-panel.js